import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["username", "email", "password", "passwordConfirmation"]
  static values = {
    usernameMinLength: { type: String, default: "Mínimo de 3 caracteres" },
    usernameMaxLength: { type: String, default: "Máximo de 30 caracteres" },
    usernameFormat: { type: String, default: "Apenas letras minúsculas, números e _" },
    emailInvalid: { type: String, default: "Insira um endereço de email válido." },
    passwordMinLength: { type: String, default: "Mínimo de 6 caracteres" },
    passwordMismatch: { type: String, default: "As senhas não coincidem" }
  }

  validateUsername() {
    const input = this.usernameTarget
    const value = input.value.trim().toLowerCase()

    this.clearError(input)
    if (!value) return

    if (value.length < 3) {
      this.setError(input, this.usernameMinLengthValue)
      return
    }

    if (value.length > 30) {
      this.setError(input, this.usernameMaxLengthValue)
      return
    }

    if (!/^[a-z0-9_]+$/.test(value)) {
      this.setError(input, this.usernameFormatValue)
      return
    }

    this.setSuccess(input)
  }

  validateEmail() {
    const input = this.emailTarget
    const value = input.value.trim()

    this.clearError(input)
    if (!value) return

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      this.setError(input, this.emailInvalidValue)
      return
    }

    this.setSuccess(input)
  }

  validatePassword() {
    const input = this.passwordTarget
    const value = input.value

    this.clearError(input)
    if (!value) return

    if (value.length < 6) {
      this.setError(input, this.passwordMinLengthValue)
      return
    }

    this.setSuccess(input)

    if (this.hasPasswordConfirmationTarget && this.passwordConfirmationTarget.value) {
      this.validatePasswordConfirmation()
    }
  }

  validatePasswordConfirmation() {
    const input = this.passwordConfirmationTarget
    const value = input.value

    this.clearError(input)
    if (!value) return

    if (value !== this.passwordTarget.value) {
      this.setError(input, this.passwordMismatchValue)
      return
    }

    this.setSuccess(input)
  }

  setError(input, message) {
    const wrap = input.closest(".floating-input")
    if (!wrap) return

    wrap.classList.remove("floating-input--success")
    wrap.classList.add("floating-input--error")

    let hint = wrap.querySelector(".floating-input__error")
    if (!hint) {
      hint = document.createElement("span")
      hint.className = "floating-input__error"
      wrap.appendChild(hint)
    }
    hint.textContent = message
  }

  setSuccess(input) {
    const wrap = input.closest(".floating-input")
    if (!wrap) return

    wrap.classList.remove("floating-input--error")
    wrap.classList.add("floating-input--success")

    const hint = wrap.querySelector(".floating-input__error")
    if (hint) hint.remove()
  }

  clearError(input) {
    const wrap = input.closest(".floating-input")
    if (!wrap) return

    wrap.classList.remove("floating-input--error", "floating-input--success")

    const hint = wrap.querySelector(".floating-input__error")
    if (hint) hint.remove()
  }
}
